import { FAST_API_URL } from "../index";

/** Секция пересборки: что заменится, если сдать папку сейчас. */
export interface RepublishSection {
    state: "clean" | "dirty" | "no_manifest" | "no_cues";
    cue_ids: string[];
    /** Все реплики папки по порядку — по нему считается расширение блока без запроса на строку. */
    ordered: string[];
    from_ms: number;
    to_ms: number;
    touched: string[];
    moved: string[];
    gone?: string[];
    total_cues: number;
    reason: string;
}

export interface RepublishSectionAnswer {
    now: RepublishSection;
    /** Папка сдана и пересобирается — правки в этих строках приедут следующим кругом. */
    rebuilding: {
        state: string;
        cue_ids: string[];
        from_ms: number;
        to_ms: number;
        handed_in_at?: string;
        message?: string;
    } | null;
    folder_num: number;
    pair: string;
}

export const getRepublishSection = async (args: {
    mediaId: string;
    folderNum: number;
    lang: string;
    languageFrom: string;
}): Promise<RepublishSectionAnswer | null> => {
    const params = new URLSearchParams({
        media: args.mediaId,
        folder_num: String(args.folderNum),
        lang: args.lang,
        language_from: args.languageFrom,
    });
    const response = await fetch(`${FAST_API_URL}/republish_section?${params.toString()}`);
    if (!response.ok) return null;
    return (await response.json()) as RepublishSectionAnswer;
};
